import React, { useEffect, useState } from "react";

// Icons
import LoadingBox from "../../../../../components/misc/Loading";
import { format } from "date-fns";
import { PF } from "../../../../../config";
import { useDispatch, useSelector } from "react-redux";
import {
  getCompanies,
  getDosages,
  getMedCategories,
  getMedicines,
} from "../../../../../reduxToolkit/features/adminPanel/medicine";

export default function PreviewLeafletPage() {
  const [loadingMain, setLoadingMain] = useState(true);

  const { leafletObj } = useSelector((state) => state.misc);

  useEffect(() => {
    setLoadingMain(true);
    if (
      leafletObj &&
      leafletObj.selectedForPreview &&
      leafletObj.settings &&
      leafletObj.siteLang
    ) {
    }
    setTimeout(() => {
      setLoadingMain(false);
    }, 2000);
  }, [leafletObj]);

  //! Translate
  // Store
  const { langArrFromClientSide } = useSelector((state) => state.misc);
  const translate0 = (String) => {
    let translation = "";
    if (langArrFromClientSide && langArrFromClientSide.length > 0) {
      const T = langArrFromClientSide.find((l) => l.title === String);
      if (T && T.value) {
        let obj = { ...T };
        if (T.value === "") obj.value = T.title;
        translation = T.value;
      } else if (T === undefined) translation = String;
    }
    return translation;
  };
  //! Translate

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const [htmlToView, setHtmlToView] = useState(``);

  //   Store
  const { medicines, categories, companies, medVariants, dosages } =
    useSelector((state) => state.medicine);

  useEffect(() => {
    if (!(medicines && medicines.length > 0)) dispatch(getMedicines());
    if (!(categories && categories.length > 0)) dispatch(getMedCategories());
    if (!(companies && companies.length > 0)) dispatch(getCompanies());
    if (!(dosages && dosages.length > 0)) dispatch(getDosages());
  }, []);

  const getImage = (imageArr) => {
    let imageUrl = ``;
    if (imageArr && imageArr.length > 0 && imageArr[0].src) {
      if (imageArr[0].src !== "")
        imageUrl = PF + "/adminPanel/medicines/img/" + imageArr[0].src;
      else imageUrl = PF + "/adminPanel/medicines/no-medicine-image.jpg";
    }
    return imageUrl;
  };

  // Get Category
  const [catList, setCatList] = useState([]);
  useEffect(() => {
    if (categories && categories.length > 0) {
      const C = categories.find((c) => c.lang === leafletObj.siteLang);
      if (C && C.data) {
        setCatList(C.data);
      }
    }
  }, [categories, leafletObj.siteLang]);

  const getCatString = (subCatArr) => {
    let cat = "";
	  if(subCatArr && subCatArr.length >0){

    let catArr = [];
    subCatArr?.forEach((x) => {
      catList.forEach((y) => {
        let Sc = y.subCatList.find(
          (sc) =>
            (leafletObj.siteLang && leafletObj.siteLang !== "en"
              ? sc.subCatDetectorId
              : sc.fixedSubCatId) === x.subCatId
        );
        if (Sc) catArr.push(y.catName);
      });
    });
    let uniqueCatArr = [...new Set(catArr)];
    cat = uniqueCatArr.join(", ");
	  }
    return cat;
  };

  // Get Sub Category
  const getSubCatString = (subCatArr) => {
    let subCat = "";
	  if(subCatArr && subCatArr.length >0){
    let scArr = [];
    subCatArr?.forEach((x) => {
      catList.forEach((y) => {
        let Sc = y.subCatList.find(
          (sc) =>
            (leafletObj?.siteLang && leafletObj?.siteLang !== "en"
              ? sc.subCatDetectorId
              : sc.fixedSubCatId) === x.subCatId
        );
        if (Sc) scArr.push(Sc.subCatName);
      });
    });
    let uniqueSubCatArr = [...new Set(scArr)];
    subCat = uniqueSubCatArr.join(", ");
	  }
    return subCat;
  };

  // Get Company
  const [companyList, setCompanyList] = useState([]);
  useEffect(() => {
    if (loadingMain && companies && companies.length > 0) {
      const C = companies.find((c) => c.lang === leafletObj?.siteLang);
      if (C && C.data) {
        setCompanyList(C.data);
      }
    }
  }, [companies, leafletObj.siteLang, loadingMain]);

  const getCompanyString = (companyId) => {
    let companyString = "";
    let C = companyList.find(
      (c) =>
        (leafletObj.siteLang && leafletObj.siteLang === "en"
          ? c.fixedCompanyId
          : c.companyDetectorId) === companyId
    );
    if (C) {
      companyString = C.companyName;
    }
    return companyString;
  };

  // Get Variant Info
  const [dosageList, setDosageList] = useState([]);
  useEffect(() => {
    if (leafletObj?.siteLang !== "" && dosages && dosages.length > 0) {
      const D = dosages.find((d) => d.lang === leafletObj?.siteLang);
      if (D && D.data) setDosageList(D.data);
      else setDosageList([]);
    }
  }, [dosages, leafletObj?.siteLang]);

  const getVariantInfo = (id) => {
    const MV = medVariants.find((mv) => mv.fixedVariantId === id);
    return MV;
  };

  const getDosageInfo = (dosageId) => {
    let dosageName = "";
    const D = dosageList.find(
      (d) =>
        (leafletObj?.siteLang !== "en"
          ? d.dosageDetectorId
          : d.fixedDosageId) === dosageId
    );
    if (D && D.dosageName) dosageName = D.dosageName;

    return dosageName;
  };

  const getVariantStringObj = (variantArr) => {
    let obj = {
      dosageString: "",
      strengthString: "",
      packTypesString: "",
      priceString: "",
    };
    let dosageArr = [];
    let strengthArr = [];
    let packTypesArr = [];
    let priceArr = [];
    variantArr.forEach((z) => {
      dosageArr.push(getDosageInfo(getVariantInfo(z.variantId)?.dosageForm));
      strengthArr.push(getVariantInfo(z.variantId)?.strength);
      packTypesArr.push(getVariantInfo(z.variantId)?.packTypes);
      priceArr.push("$" + getVariantInfo(z.variantId)?.sellingPrice);
    });

    let uniqueDosageArr = [...new Set(dosageArr)];
    let uniqueStrengthArr = [...new Set(strengthArr)];
    let uniquePackTypesArr = [...new Set(packTypesArr)];
    let uniquePriceArr = [...new Set(priceArr)];
    obj.dosageString = uniqueDosageArr.join(", ");
    obj.strengthString = uniqueStrengthArr.join(", ");
    obj.packTypesString = uniquePackTypesArr.join(", ");
    if (uniquePriceArr.length > 1) {
      obj.priceString = `${uniquePriceArr[0]} - ${
        uniquePriceArr[uniquePriceArr.length - 1]
      }`;
    } else {
      obj.priceString = uniquePriceArr.join(", ");
    }
    return obj;
  };

  useEffect(() => {
    if (!loadingMain) {
      setLoading(true);
      let newHtml = html;
      newHtml = newHtml.replace(
        "{__header_text}",
        leafletObj?.settings.headerText
      );

      if (leafletObj.settings.date) {
        newHtml = newHtml.replace(
          "{__date_string}",
          `${translate0("Date")}: ${format(
            new Date(leafletObj?.settings?.date),
            "P"
          )}`
        );
      }
      newHtml = newHtml.replace(
        "{__footer_text}",
        leafletObj?.settings.footerText
      );
      let medListHtml = ``;
      if (
        leafletObj?.selectedForPreview &&
        leafletObj?.selectedForPreview.length > 0
      ) {
        leafletObj?.selectedForPreview.forEach((x, i) => {
          medListHtml =
            medListHtml +
            `<section class="med-list">
          <div class="box">
            <div>
            ${
              leafletObj?.settings.fieldsToView.image
                ? `<img            
                      src=${getImage(x.image)}
                      alt=${x.genericBrand}
                      class="med-image"
                  />`
                : ""
            } 
            
            </div>
            <div class="basic-info">
            ${
              leafletObj?.settings.fieldsToView.generic
                ? `<p>${translate0("Generic")}: ${x.generic}</p>`
                : ""
            } 
              
              ${
                leafletObj?.settings.fieldsToView.genericBrand
                  ? `<p>${translate0("Generic Brand")}: ${x.genericBrand}</p>`
                  : ""
              } 
              
              ${
                leafletObj?.settings.fieldsToView.category
                  ? `<p>${translate0("Category")}: ${getCatString(
                      x.subCats
                    )}</p>`
                  : ""
              }  
              
              ${
                leafletObj?.settings.fieldsToView.subCategory
                  ? `<p>${translate0("Sub Category")}: ${getSubCatString(
                      x.subCats
                    )}</p>`
                  : ""
              }  

              ${
                leafletObj?.settings.fieldsToView.company
                  ? `<p>${translate0("Mfg Company")}: ${getCompanyString(
                      x.companyId
                    )}</p>`
                  : ""
              }  
              
              ${
                leafletObj?.settings.fieldsToView.originator
                  ? `<p>${translate0("Originator")}: ${x.originator}</p>`
                  : ""
              }              
            </div>
            <div class="variant-info">              
              ${
                leafletObj?.settings.fieldsToView.dosage
                  ? `<p>${translate0("Dosage Form")}: ${
                      getVariantStringObj(x.variants).dosageString
                    }</p>`
                  : ""
              }               
              ${
                leafletObj?.settings.fieldsToView.strength
                  ? `<p>${translate0("Strength")}: ${
                      getVariantStringObj(x.variants).strengthString
                    }</p>`
                  : ""
              }              
              ${
                leafletObj?.settings.fieldsToView.packSize
                  ? `<p>${translate0("Pack Types")}: ${
                      getVariantStringObj(x.variants).packTypesString
                    }</p>`
                  : ""
              }
              ${
                leafletObj?.settings.fieldsToView.price
                  ? `<p>${translate0("Price")}: ${
                      getVariantStringObj(x.variants).priceString
                    }</p>`
                  : ""
              }              
              ${
                leafletObj?.settings.fieldsToView.availability
                  ? `<p>${translate0("Availability")}: ${
                      x.visible
                        ? translate0("Available")
                        : translate0("Not Available")
                    }</p>`
                  : ""
              }
            </div>
          </div>
        </section>`;

          if ((i + 1) % 10 === 0) {
            if (i + 1 < 10)
              medListHtml = medListHtml + `<div style="margin-top: 190px"/>`;
            else medListHtml = medListHtml + `<div style="margin-top: 170px"/>`;
          }
        });
      }
      newHtml = newHtml.replace("{__insert_meds_here} ", medListHtml);
      setHtmlToView(newHtml);
      setTimeout(() => setLoading(false), 3000);
    }
  }, [
    leafletObj.selectedForPreview,
    leafletObj.settings.date,
    leafletObj.settings.fieldsToView,
    leafletObj.settings.footerText,
    leafletObj.settings.headerText,
    leafletObj.siteLang,
    loadingMain,
  ]);

  return (
    <>
      {loadingMain || loading ? (
        <LoadingBox w={"100%"} />
      ) : (
        <>
          <div dangerouslySetInnerHTML={{ __html: htmlToView }} />
        </>
      )}
    </>
  );
}

const html = `
<style>
.topbar {
  // display: -webkit-box;
  // display: flex;
  // -webkit-box-pack: space-between;
  // justify-content: space-between;
  width: 90%;
  margin: auto;
}

.top-divider,
footer {
  width: 90%;
  margin: 10px auto;
}

.med-list {
  width: 90%;
  margin-left: auto;
  margin-right: auto;  
  height: 230px;
  margin-bottom:10px;
}

.box {
  display: -webkit-box;
  display: flex;
  background: #E6E6E3;
  border-radius: .5rem;

}

.med-image {
  padding:10px;
  height: 160px;
  width: 160px;
  object-fit: contain;
}

p {
  font-size: 12px;
}

.basic-info,
.variant-info {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  margin-top: 5px;
  flex: 1;
  width:280px;
  padding:0px 10px ;
}

</style>
<div class="topbar">
  <p>{__header_text}</p>
  <p>{__date_string}</p>
</div>
<hr class="top-divider" />
{__insert_meds_here}            
<footer>
  {__footer_text}                
</footer>
`;
